import { graphql } from '../gql'

/**
 * GraphQL operations for the Work Ticket feature (CRE-16).
 */

/** Query: Get work ticket data for an order. */
export const GetOrderWorkTicketData = graphql(`
	query GetOrderWorkTicketData($orderId: Int!) {
		order(id: $orderId) {
			id
			dateOfServiceLocal
			status
			statusDetails {
				slug
				name
			}
			branchId
			comments {
				id
				personId
				text
				metadata {
					key
					value
				}
			}
			site {
				id
				address {
					id
					timezone
				}
			}
			signature {
				id
				metadata {
					key
					value
				}
			}
			planned {
				id
				inventory {
					id
					quantity
					item {
						id
						name
						branchId
						category
						displayUnit
						visibility {
							operatorWorkTicket
							operatorAssignment
							customerWorkTicket
						}
					}
				}
				schedule {
					id
					scheduleIndex
					startTime
					endTime
					step
					stepDetails {
						slug
						name
					}
					metrics {
						key
						value
					}
				}
			}
			actuals {
				id
				subType
				inventory {
					id
					quantity
					item {
						id
						name
						branchId
						category
						displayUnit
						visibility {
							operatorWorkTicket
							operatorAssignment
							customerWorkTicket
						}
					}
				}
				schedule {
					id
					scheduleIndex
					startTime
					endTime
					step
					stepDetails {
						slug
						name
					}
					metrics {
						key
						value
					}
				}
			}
		}
	}
`)

/** Query: Get all inventory items. */
export const GetWorkTicketInventory = graphql(`
	query GetWorkTicketInventory {
		inventory(where: { active: { equals: true } }) {
			id
			name
			branchId
			category
			displayUnit
			visibility {
				operatorWorkTicket
				operatorAssignment
				customerWorkTicket
			}
		}
	}
`)

/** Mutation: Submit work ticket data. */
export const SubmitWorkTicket = graphql(`
	mutation SubmitWorkTicket(
		$data: OrderUpdateInput!
		$where: OrderWhereUniqueInput!
	) {
		updateOrder(data: $data, where: $where) {
			id
			status
			statusDetails {
				slug
				name
			}
		}
	}
`)
